﻿module PortalLibs.Client.Model


open System

[<CustomEquality; NoComparison>]
type EditControlMode<'T> =
  { OnChange: 'T option -> unit
    StopPropagation: bool }

  interface IEquatable<EditControlMode<'T>> with
    member this.Equals other =
      this.StopPropagation = other.StopPropagation
      && Object.ReferenceEquals(this.OnChange, other.OnChange)

  override this.Equals other =
    match other with
    | :? EditControlMode<'T> as ue -> (this :> IEquatable<_>).Equals ue
    | _ -> false

  override this.GetHashCode() = this.GetHashCode()




type ControlEditMode<'T> =
  | ReadOnly
  | Edit of EditControlMode<'T>
